"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMagicLinkRoute = exports.magicLinkOAuthSignin = exports.snapchatOAuthSignin = exports.facebookOAuthSignin = exports.googleOAuthSignin = void 0;
const react_1 = __importStar(require("react"));
const JSONParser_1 = require("lincd-jsonld/lib/utils/JSONParser");
const googleOAuthSignin = function () {
    //return Server.customPost('/google-oauth');
    // return Server.call('lincd-passport','googleOAuthSignin');
    let url = `${process.env.SITE_ROOT}/lincd-passport/auth/google`;
    return window.location.assign(url);
};
exports.googleOAuthSignin = googleOAuthSignin;
const facebookOAuthSignin = function () {
    let url = `${process.env.SITE_ROOT}/lincd-passport/auth/facebook`;
    return window.location.assign(url);
};
exports.facebookOAuthSignin = facebookOAuthSignin;
const snapchatOAuthSignin = function () {
    let url = `${process.env.SITE_ROOT}/lincd-passport/auth/snapchat`;
    return window.location.assign(url);
};
exports.snapchatOAuthSignin = snapchatOAuthSignin;
const magicLinkOAuthSignin = function (email) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetch(`${process.env.SITE_ROOT}/lincd-passport/auth/magiclogin`, {
            method: 'POST',
            body: JSON.stringify({
                destination: email,
                name: email,
            }),
            headers: { 'Content-Type': 'application/json' },
        })
            .then((res) => res.json())
            .then((response) => __awaiter(this, void 0, void 0, function* () {
            if (response.data) {
                let parseResult = yield JSONParser_1.JSONParser.parseObject(response.data);
                response.data = parseResult.content;
            }
            return response;
        }))
            .catch((error) => {
            console.error('Error:', error);
        });
    });
};
exports.magicLinkOAuthSignin = magicLinkOAuthSignin;
function createMagicLinkRoute(indexRoute, renderLoading) {
    const LazyMagicLinkCallback = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../components/MagicLoginCallback' /* webpackPrefetch: true */))));
    return {
        //TODO: make frontend URL configurable with an environment variable
        path: '/auth/magiclogin/verify',
        render: () => (react_1.default.createElement(LazyMagicLinkCallback, { indexRoute: indexRoute, renderLoading: renderLoading })),
    };
}
exports.createMagicLinkRoute = createMagicLinkRoute;
//# sourceMappingURL=passportAuth.js.map